import Loader from "Components/Loader/loader";
import { updateGroups } from "Redux/Actions/groupsActions";
import { updateMenu } from "Redux/Actions/menuActions";
import { Divider } from "primereact/divider";
import { InputText } from "primereact/inputtext";
import { ScrollPanel } from "primereact/scrollpanel";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { HiSearch } from "react-icons/hi";
import { connect } from "react-redux";
import GroupeCardMember from "../GroupeCard/GroupeCardMember/GroupeCardMember";
import "./GroupeMembership.scss";

const GroupeMembership = (props) => {
  const { t } = useTranslation("common");
  const [filtreMotsCles, setFiltreMotsCles] = useState("");

  // Filtrage local sur les données passées en props
  const filteredData = props.myGroups?.data?.filter(g =>
      g.label?.toLowerCase().includes(filtreMotsCles)
  ) ?? [];

    const itemHeight = 80;
    const maxHeight = 450;

    const dynamicHeight = Math.min(filteredData.length * itemHeight, maxHeight);

  return (
      <div className="membership_container">
        <h2 className="membership_style_h2">
          {props.title || t("footerApresConnexion.li_groupes_echanges")}
        </h2>
        <span>
        <HiSearch className="searchBar_groupe_echange_icon" />
        <InputText
            placeholder={t("groupManagement.searchGroup")}
            className="membership_input_text"
            value={filtreMotsCles}
            onChange={(e) => setFiltreMotsCles(e.target.value.toLowerCase())}
        />
      </span>
        <div className="membership_groupe_cards" key={props.myGroups}>
          <ScrollPanel style={{ width: "100%", height: dynamicHeight }}>
            {!props.myGroups.loaded && <Loader />}
            {filteredData.length > 0 && props.myGroups.loaded
                ? filteredData.map((group, index) => (
                    <React.Fragment key={index}>
                      <GroupeCardMember
                          group={group}
                          image={group.imageUrl ? "link" : "img1"}
                          link={group.imageUrl}
                          setSelectGroup={props.setSelectGroup ?? null}
                          setLeaveGroup={props.setLeaveGroup ?? null}
                      />
                      {index !== filteredData.length - 1 && (
                          <>
                            <Divider className="divider_desktop" />
                            <Divider layout="vertical" className="divider_mobile" />
                          </>
                      )}
                    </React.Fragment>
                ))
                : props.myGroups.loaded && (
                <p style={{ textAlign: "center" }}>
                  {filtreMotsCles
                      ? t("groupManagement.noGroupsMatch")
                      : t("groupManagement.noGroupsBelong")}
                </p>
            )}
          </ScrollPanel>
        </div>
      </div>
  );
};
GroupeMembership.propTypes = {
  groups: PropTypes.any,
  myGroups: PropTypes.object,
  handleUpdateGroups: PropTypes.func,
  setSelectGroup: PropTypes.func,
  items: PropTypes.any,
  handleMenu: PropTypes.func,
  auth: PropTypes.object,
  from: PropTypes.string,
  setLeaveGroup: PropTypes.func,
  states: PropTypes.any,
  title: PropTypes.string,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  groups: state.groups,
  items: state.items,
  states: state.states,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateGroups: (value) => {
    dispatch(updateGroups(value));
  },
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupeMembership);
